import { useCallback, useEffect, useState } from 'react'
import { useUserContext } from '~/contexts/UserContext'
import { usePlatform } from '~/contexts/PlatformContext'
import { getUserProfile } from '~/services/userService'
import { User } from '~/types/ResponseType'

export function useUser(): User {
  const { user } = useUserContext()

  return user || ({} as User)
}

export function useUserWithLoadedState() {
  const [loaded, setLoaded] = useState(false)
  const [user, setUser] = useState<User | null>(null)
  const { authVersion, ready, isPlugin } = usePlatform()

  const refetch = useCallback(() => {
    return getUserProfile()
      .then(setUser)
      .finally(() => setLoaded(true))
  }, [])

  useEffect(() => {
    if (ready) {
      refetch()
    }
  }, [ready, refetch])

  useEffect(() => {
    if (authVersion > 0) {
      console.log(
        '[useUserWithLoadedState] authVersion changed to',
        authVersion,
        '- refetching profile'
      )
      refetch().then(() => {
        console.log('[useUserWithLoadedState] profile refetch complete')
      })
    }
  }, [authVersion, refetch])

  useEffect(() => {
    if (!isPlugin) return
    const handleLogout = () => {
      setUser(null)
      setLoaded(true)
    }
    window.addEventListener('plugin-auth-logout', handleLogout)
    return () => window.removeEventListener('plugin-auth-logout', handleLogout)
  }, [isPlugin])

  return {
    user,
    loaded,
    refetch
  }
}
